define("SDB.SelectYourVehicle.SS2Model", [
  "SCModel",
  "Utils",
  "AjaxRequestsKiller",
  "SDB.PLP.Modifications.SS2Model",
  "SDB.SelectWheelsOrTires.SS2Model",
  "Singleton",
], function (
  SCModelComponent,
  Utils,
  AjaxRequestsKiller,
  SDBPLPModificationsSS2Model,
  SDBSelectWheelsOrTiresSS2Model,
  Singleton
) {
  "use strict";

  var SCModel = SCModelComponent.SCModel;

  var SDBSelectYourVehicleSS2Model = function SDBSelectYourVehicleSS2Model() {
    SCModel.call(this);

    this.urlRoot = function () {
      return Utils.getAbsoluteUrl(
        getExtensionAssetsPath(
          "Modules/SDBSelectYourVehicle/SuiteScript2/SDB.SelectYourVehicle.Service.ss"
        ),
        true
      );
    };

    this.fixedOptions = ["year", "make", "model"];
    this.set(
      {
        extraOptions: [],
        finalTrims: false,
        allOptionsSelected: false,
      },
      {
        wait: true,
      }
    );
    var wheelsOrTiresModel = SDBSelectWheelsOrTiresSS2Model.getInstance();

    this.getNextOption = function getNextOption(data, async) {
      var self = this;
      var isAsync = !!async;
      this.set({ finalTrims: false }, { silent: true });
      this.set({ allOptionsSelected: false }, { silent: true });
      if (data)
        var selectedTireSize = _.find(
          JSON.parse(data.selection),
          function (element) {
            return element.indexOf("Tire Size:") != -1;
          }
        );
      if (selectedTireSize)
        selectedTireSize = selectedTireSize.replace("Tire Size:", "");
      if (selectedTireSize) {
        self.unset("chooseSize");
        var selectedSize = JSON.parse(data.selection);
        selectedSize = selectedSize[selectedSize.length - 1];
        var cookies = wheelsOrTiresModel.getCookieOptions();
        var cookiesObject = {};
        if (cookies && cookies.length > 1) {
          cookiesObject = _.reduce(
            cookies,
            function (acc, item) {
              var trimmed = item.replace(/^\s+|\s+$/g, "");
              var parts = trimmed.split("=");
              var key = parts[0];
              var value = parts.slice(1).join("=");
              acc[key] = value;
              return acc;
            },
            {}
          );
        }
        var sizeNumber = selectedSize.match(/\d+(\.\d+)?/g);
        if (sizeNumber)
          cookiesObject.selectedSize = selectedSize.match(/\d+(\.\d+)?/g)[0];
        wheelsOrTiresModel.setCookieOptions(cookiesObject);
        // self.set({ finalTrims: true });
        if (sizeNumber) {
          self.set({ allOptionsSelected: true });
          return;
        }
        self.set({ allOptionsSelected: false });
        var extraOptions = self.get("extraOptions");
        extraOptions.push({ name: "Tire Size", facet: "" });
        self.set({ extraOptions: extraOptions });
        self.set({ chooseSize: true });
        return;
      }

      var option_fetch_promise = this.fetch({
        async: isAsync,
        cache: true,
        AjaxRequestsKiller: AjaxRequestsKiller.getKillerId(),
        data: data,
      });

      return option_fetch_promise
        .done(function (response) {
          if (!response || !response.data) return;
          var result = JSON.parse(response.data);
          var Menu = result.Menu;
          var isFixedOption = !!(self.fixedOptions.indexOf(Menu.Key) !== -1);
          var valueToSet = isFixedOption ? Menu.Title : Menu.Key.toPascalCase();

          if (!result.FinalTrims) self.set(valueToSet, Menu, { wait: true });
          else self.set("Configid", Menu, { wait: true });

          if (!isFixedOption) {
            if (!result.FinalTrims) {
              var extraOptions = self.get("extraOptions");
              extraOptions.push({ name: Menu.Key.toUpperCase(), facet: "" });
              self.set({ extraOptions: extraOptions });
            } else {
              var filtersModel = SDBPLPModificationsSS2Model.getInstance();

              filtersModel
                .fetch({
                  async: false,
                  data: {
                    vehicleId: result.BestConfiguration.Value,
                    chooseSize: true,
                  },
                })
                .done(function (result) {
                  var data = JSON.parse(result);
                  var sizeOptions = [];
                  data.forEach(function (tireSize) {
                    var tireSizeNumbers = tireSize.match(/\d+(\.\d+)?/g);
                    var sizeOption = {
                      Label: tireSize,
                      Value: tireSizeNumbers[tireSizeNumbers.length - 1],
                    };
                    var sizeDuplicate = _.find(sizeOptions, function (value) {
                      return value.Value == sizeOption.Value;
                    });
                    if (!sizeDuplicate) sizeOptions.push(sizeOption);
                  });
                  if (sizeOptions.length == 1) {
                    var cookies = wheelsOrTiresModel.getCookieOptions();
                    var cookiesObject = {};
                    if (cookies && cookies.length > 1) {
                      cookiesObject = _.reduce(
                        cookies,
                        function (acc, item) {
                          var trimmed = item.replace(/^\s+|\s+$/g, "");
                          var parts = trimmed.split("=");
                          var key = parts[0];
                          var value = parts.slice(1).join("=");
                          acc[key] = value;
                          return acc;
                        },
                        {}
                      );
                    }
                    cookiesObject.selectedSize = sizeOptions[0].Value;
                    wheelsOrTiresModel.setCookieOptions(cookiesObject);
                    // self.set({ finalTrims: true });
                    self.set({ allOptionsSelected: true });
                    return;
                  }
                  self.set(
                    "Tire Size",
                    {
                      Title: "Tire Size",
                      Description: "Select a Tire Size",
                      Key: "Tire Size",
                      Options: sizeOptions,
                    },
                    { wait: true }
                  );

                  var extraOptions = self.get("extraOptions");
                  extraOptions.push({ name: "Tire Size", facet: "" });
                  self.set({ extraOptions: extraOptions });
                  self.set({ chooseSize: true });
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    };

    this.getConfigurationId = function getConfigurationId() {
      var vehicleConfiguration = this.get("Configid");
      if (!vehicleConfiguration) return null;

      var configOption = _.first(vehicleConfiguration.Options);
      return configOption.Value;
    };
  };

  SDBSelectYourVehicleSS2Model.prototype = SCModel.prototype;
  SDBSelectYourVehicleSS2Model.prototype.constructor =
    SDBSelectYourVehicleSS2Model;

  return _.extend(SDBSelectYourVehicleSS2Model, Singleton);
});
